// Core
import React from "react";

// Instruments
import contacts from "../theme/assets/data/contacts.json";

// Components
import SectionHeading from "./SectionHeading";
import Contact from "./Contact";

export default class Contacts extends React.Component {
    render () {
        const contactList = contacts.map((contact) => {
            return (
                <Contact
                    action = { contact.action }
                    address = { contact.address }
                    key = { contact.id }
                />
            );
        });

        return (
            <div className = 'contacts'>
                <SectionHeading number = '03.' title = 'Контакты' />
                {contactList}
            </div>
        );
    }
}
